export const CORPORATE = {
  en: {
    sust: {
      navLabel: "Sustainability",
      kicker: "Sustainability",
      title: "Responsible by design.",
      sub: "We are committed to acting responsibly — in how we manufacture, how we ship, and how we treat the people who make our work possible.",
      envK: "01 Environment",
      envT: "Environmental responsibility",
      envB1: "We are fully aware that heavy manufacturing can affect the environment around it. That awareness is where our commitment begins: for VANROCK, environmental responsibility is not a secondary objective but a founding principle, managed with discipline and a long-term industrial vision.",
      envB2: "Our manufacturing follows a lean approach supported by process automation, designed to reduce scrap, energy waste and unnecessary consumption. Forging, machining and finishing under one roof shortens the production chain — fewer transfers, less transport, less waste.",
      envB3: "We consolidate shipments and optimise packaging and logistics to lower the footprint of every order that leaves our warehouses.",
      envB4: "The result is value created sustainably — for the company, for the people who work with us and for every stakeholder in our supply chain.",
      socK: "02 People",
      socT: "Social responsibility",
      socB1: "People are at the heart of every decision we make. We value talent, long-term relationships and the local communities around our sites, and we encourage training, autonomy and mutual trust at every level of the company.",
      socB2: "We believe an inclusive, transparent and collaborative environment is the foundation of genuine, lasting growth — one that reflects the diversity of the communities in which we operate.",
      socB3: "We invest continuously in modern equipment and safer processes to minimise risk, prevent accidents and guarantee working conditions that respect the dignity of every individual.",
      socB4: "These principles are formalised in a Code of Conduct that guides behaviour across the company, supported by a confidential reporting channel that protects anyone who raises a concern.",
      govK: "03 Governance",
      govT: "Governance",
      govB1: "We believe in a solid, structured and transparent governance system — one capable of guiding the company's development ethically and responsibly while generating long-term value for all stakeholders.",
      govB2: "For us, governance is more than a set of rules: it is how we build trust, keep our actions consistent and turn the values we believe in into daily practice.",
      govB3: "The system is supported by internal oversight, regular audit activity and process management focused on risk prevention, traceability and performance measurement — from raw material to dispatched part.",
      govB4: "Our quality, environmental and health & safety management is built on the principles of internationally recognised standards such as ISO 9001, ISO 14001 and ISO 45001.",
      govB5: "Ethical conduct is a condition of doing business with us — internally, with our suppliers and across our dealer network.",
    },
    careers: {
      navLabel: "Careers",
      kicker: "Careers",
      title: "Build your career on solid ground.",
      sub: "VANROCK is growing across four continents. We are always interested in people who take engineering, quality and service seriously.",
      whyK: "Why VANROCK",
      whyT: "What you can expect",
      w1t: "Real manufacturing",
      w1b: "Forging, machining, heat treatment and assembly under one roof — you work close to the product, not far from it.",
      w2t: "Global reach",
      w2b: "Offices in Europe, North America, Australia and India, and a dealer network that spans the world.",
      w3t: "Room to grow",
      w3b: "A growing company means growing responsibility. People who perform take on more — quickly.",
      areasK: "Areas of work",
      areasT: "Where you could work",
      a1: "Production & Engineering",
      a2: "Sales & Dealer Development",
      a3: "Warehouse & Logistics",
      a4: "Administration & Support",
      applyT: "Interested in joining?",
      applyB: "We review every application we receive. Tell us who you are, what you do best and which office or area you are interested in.",
      applyCta: "Contact us",
      formK: "Application",
      formT: "Apply to VANROCK",
      emailNote: "Prefer email? Send your CV and a short introduction to",
      secPersonal: "Personal details",
      secPosition: "Position",
      secExperience: "Experience",
      secDocs: "Documents & message",
      f_first: "First name",
      f_last: "Last name",
      f_email: "Email",
      f_phone: "Phone",
      f_country: "Country",
      f_city: "City",
      f_area: "Area of work",
      f_office: "Preferred office",
      f_position: "Role / position",
      f_type: "Employment type",
      t_full: "Full-time",
      t_part: "Part-time",
      t_intern: "Internship / apprenticeship",
      f_employer: "Current employer",
      f_role: "Current role",
      f_years: "Years of experience",
      f_education: "Highest education",
      f_langs: "Languages spoken",
      f_linkedin: "LinkedIn profile",
      f_salary: "Salary expectation",
      f_start: "Earliest start date",
      f_relocate: "I am willing to relocate",
      f_heard: "How did you hear about us",
      f_cover: "Cover letter / message",
      f_cv: "CV / résumé (PDF or Word)",
      attach: "Attach CV",
      uploading: "Uploading…",
      uploaded: "Attached",
      submit: "Submit application",
      sending: "Sending…",
      okT: "Application received",
      okB: "Thank you — our team will review your application and contact you if there is a match. You can also reach us at careers@vanrocktracksolutions.com.",
      err: "Something went wrong. Please try again or email careers@vanrocktracksolutions.com.",
      select: "Select…",
    },
    news: {
      navLabel: "Newsroom",
      kicker: "Newsroom",
      title: "Newsroom.",
      sub: "Company announcements and product updates from VANROCK Track Solutions.",
      n1tag: "Company",
      n1date: "May 2026",
      n1t: "VANROCK opens European office in Munich",
      n1b: "With the opening of our European Sales & Dealer Development Office at Marcel-Breuer-Str. 15 in Munich, VANROCK moves closer to its dealers across Europe. The new office coordinates dealer development, technical support and commercial operations for the entire region — shortening response times and strengthening local partnerships.",
      n2tag: "Product",
      n2date: "June 2026",
      n2t: "Rubber tracks join the VANROCK range",
      n2b: "VANROCK expands its range with a complete line of rubber tracks for mini excavators, compact track loaders and tracked dumpers. Built with continuous steel cords and wear-resistant rubber compounds, every track passes the same inspection standards as our steel undercarriage components — available through the VANROCK dealer network.",
      n3tag: "Product",
      n3date: "June 2026",
      n3t: "Rubber pads complete the range",
      n3b: "Alongside rubber tracks, VANROCK adds a full program of rubber pads — bolt-on, clip-on, chain-on and road pads — protecting asphalt and paved surfaces while extending undercarriage life. Matched to VANROCK track groups and shoes, all pads are available through the VANROCK dealer network.",
      tabAll: "All",
      tickerT: "VANROCK is now one office stronger — European Sales & Dealer Development Office, Munich.",
      tickerCta: "Read more",
      tabNews: "News",
      tabEvents: "Events",
      e1tag: "Event",
      e1t: "Dealer onboarding sessions",
      e1b: "Regional VANROCK offices hold regular onboarding and product-training sessions for new and prospective dealers. Contact your regional office to join the next session.",
      mediaT: "Media inquiries",
      mediaB: "For press and media requests, reach out through our contact page and we will route your inquiry to the right office.",
      mediaCta: "Contact us",
    },
  },
  es: {
    sust: {
      navLabel: "Sostenibilidad",
      kicker: "Sostenibilidad",
      title: "Responsables por diseño.",
      sub: "Nos comprometemos a actuar con responsabilidad — en cómo fabricamos, cómo enviamos y cómo tratamos a las personas que hacen posible nuestro trabajo.",
      envK: "01 Medio ambiente",
      envT: "Responsabilidad ambiental",
      envB1: "Somos plenamente conscientes de que la industria pesada puede afectar al entorno que la rodea. De esa conciencia nace nuestro compromiso: para VANROCK, la responsabilidad ambiental no es un objetivo secundario sino un principio fundacional, gestionado con disciplina y una visión industrial a largo plazo.",
      envB2: "Nuestra fabricación sigue un enfoque lean apoyado en la automatización de procesos, diseñado para reducir mermas, desperdicio energético y consumos innecesarios. Forjar, mecanizar y acabar bajo un mismo techo acorta la cadena de producción — menos transferencias, menos transporte, menos residuos.",
      envB3: "Consolidamos envíos y optimizamos embalaje y logística para reducir la huella de cada pedido que sale de nuestros almacenes.",
      envB4: "El resultado es valor creado de forma sostenible — para la empresa, para las personas que trabajan con nosotros y para todos los actores de nuestra cadena de suministro.",
      socK: "02 Personas",
      socT: "Responsabilidad social",
      socB1: "Las personas están en el corazón de cada decisión que tomamos. Valoramos el talento, las relaciones a largo plazo y las comunidades locales que rodean nuestras plantas, y fomentamos la formación, la autonomía y la confianza mutua en todos los niveles de la empresa.",
      socB2: "Creemos que un entorno inclusivo, transparente y colaborativo es la base de un crecimiento auténtico y duradero — un entorno que refleja la diversidad de las comunidades en las que operamos.",
      socB3: "Invertimos continuamente en equipamiento moderno y procesos más seguros para minimizar riesgos, prevenir accidentes y garantizar condiciones de trabajo que respeten la dignidad de cada persona.",
      socB4: "Estos principios se formalizan en un Código de Conducta que guía el comportamiento en toda la empresa, respaldado por un canal de denuncias confidencial que protege a quien plantea una preocupación.",
      govK: "03 Gobernanza",
      govT: "Gobernanza",
      govB1: "Creemos en un sistema de gobernanza sólido, estructurado y transparente, capaz de guiar el desarrollo de la empresa de forma ética y responsable, generando valor a largo plazo para todos los grupos de interés.",
      govB2: "Para nosotros, la gobernanza es más que un conjunto de normas: es la forma en que construimos confianza, mantenemos la coherencia de nuestras acciones y convertimos nuestros valores en práctica diaria.",
      govB3: "El sistema se apoya en supervisión interna, auditorías periódicas y una gestión de procesos centrada en la prevención de riesgos, la trazabilidad y la medición del desempeño — desde la materia prima hasta la pieza expedida.",
      govB4: "Nuestra gestión de calidad, medio ambiente y seguridad y salud se basa en los principios de estándares reconocidos internacionalmente como ISO 9001, ISO 14001 e ISO 45001.",
      govB5: "La conducta ética es una condición para trabajar con nosotros — internamente, con nuestros proveedores y en toda nuestra red de distribuidores.",
    },
    careers: {
      navLabel: "Trabaja con nosotros",
      kicker: "Empleo",
      title: "Construye tu carrera sobre terreno firme.",
      sub: "VANROCK crece en cuatro continentes. Siempre nos interesan las personas que se toman en serio la ingeniería, la calidad y el servicio.",
      whyK: "Por qué VANROCK",
      whyT: "Qué puedes esperar",
      w1t: "Fabricación real",
      w1b: "Forja, mecanizado, tratamiento térmico y montaje bajo un mismo techo — trabajas cerca del producto, no lejos de él.",
      w2t: "Alcance global",
      w2b: "Oficinas en Europa, Norteamérica, Australia e India, y una red de distribuidores que abarca el mundo.",
      w3t: "Espacio para crecer",
      w3b: "Una empresa que crece significa responsabilidades que crecen. Quien rinde, asume más — rápido.",
      areasK: "Áreas de trabajo",
      areasT: "Dónde podrías trabajar",
      a1: "Producción e Ingeniería",
      a2: "Ventas y Desarrollo de Distribuidores",
      a3: "Almacén y Logística",
      a4: "Administración y Soporte",
      applyT: "¿Te interesa unirte?",
      applyB: "Revisamos todas las candidaturas que recibimos. Cuéntanos quién eres, qué haces mejor y qué oficina o área te interesa.",
      applyCta: "Contáctanos",
      formK: "Candidatura",
      formT: "Únete a VANROCK",
      emailNote: "¿Prefieres el correo? Envía tu CV y una breve presentación a",
      secPersonal: "Datos personales",
      secPosition: "Puesto",
      secExperience: "Experiencia",
      secDocs: "Documentos y mensaje",
      f_first: "Nombre",
      f_last: "Apellidos",
      f_email: "Correo electrónico",
      f_phone: "Teléfono",
      f_country: "País",
      f_city: "Ciudad",
      f_area: "Área de trabajo",
      f_office: "Oficina preferida",
      f_position: "Puesto / función",
      f_type: "Tipo de empleo",
      t_full: "Jornada completa",
      t_part: "Jornada parcial",
      t_intern: "Prácticas / aprendizaje",
      f_employer: "Empresa actual",
      f_role: "Puesto actual",
      f_years: "Años de experiencia",
      f_education: "Nivel de estudios",
      f_langs: "Idiomas",
      f_linkedin: "Perfil de LinkedIn",
      f_salary: "Expectativa salarial",
      f_start: "Fecha de inicio más próxima",
      f_relocate: "Estoy dispuesto a trasladarme",
      f_heard: "¿Cómo nos has conocido?",
      f_cover: "Carta de presentación / mensaje",
      f_cv: "CV (PDF o Word)",
      attach: "Adjuntar CV",
      uploading: "Subiendo…",
      uploaded: "Adjuntado",
      submit: "Enviar candidatura",
      sending: "Enviando…",
      okT: "Candidatura recibida",
      okB: "Gracias — nuestro equipo revisará tu candidatura y te contactará si hay coincidencia. También puedes escribirnos a careers@vanrocktracksolutions.com.",
      err: "Algo ha fallado. Inténtalo de nuevo o escribe a careers@vanrocktracksolutions.com.",
      select: "Seleccionar…",
    },
    news: {
      navLabel: "Sala de prensa",
      kicker: "Sala de prensa",
      title: "Newsroom.",
      sub: "Anuncios corporativos y novedades de producto de VANROCK Track Solutions.",
      n1tag: "Empresa",
      n1date: "Mayo 2026",
      n1t: "VANROCK abre su oficina europea en Múnich",
      n1b: "Con la apertura de nuestra Oficina Europea de Ventas y Desarrollo de Distribuidores en Marcel-Breuer-Str. 15, Múnich, VANROCK se acerca a sus distribuidores en toda Europa. La nueva oficina coordina el desarrollo de distribuidores, el soporte técnico y las operaciones comerciales de toda la región, reduciendo los tiempos de respuesta y reforzando las alianzas locales.",
      n2tag: "Producto",
      n2date: "Junio 2026",
      n2t: "Las orugas de goma se suman a la gama VANROCK",
      n2b: "VANROCK amplía su gama con una línea completa de orugas de goma para miniexcavadoras, cargadores compactos de orugas y dumpers de orugas. Fabricadas con cables de acero continuos y compuestos de goma resistentes al desgaste, cada oruga supera los mismos estándares de inspección que nuestros componentes de acero — disponibles a través de la red de distribuidores VANROCK.",
      n3tag: "Producto",
      n3date: "Junio 2026",
      n3t: "Los tacos de goma completan la gama",
      n3b: "Junto a las orugas de goma, VANROCK añade un programa completo de tacos de goma — bolt-on, clip-on, chain-on y road pads — que protegen el asfalto y las superficies pavimentadas mientras prolongan la vida del tren de rodaje. Compatibles con las cadenas y tejas VANROCK, todos los tacos están disponibles a través de la red de distribuidores VANROCK.",
      tabAll: "Todo",
      tickerT: "VANROCK crece con una nueva oficina — Oficina Europea de Ventas y Desarrollo de Distribuidores, Múnich.",
      tickerCta: "Leer más",
      tabNews: "Noticias",
      tabEvents: "Eventos",
      mediaT: "Consultas de prensa",
      mediaB: "Para solicitudes de prensa y medios, escríbenos a través de nuestra página de contacto y dirigiremos tu consulta a la oficina adecuada.",
      mediaCta: "Contáctanos",
    },
  },
  it: {
    sust: {
      navLabel: "Sostenibilità",
      kicker: "Sostenibilità",
      title: "Responsabili per progetto.",
      sub: "Ci impegniamo ad agire in modo responsabile — nel modo in cui produciamo, spediamo e trattiamo le persone che rendono possibile il nostro lavoro.",
      envK: "01 Ambiente",
      envT: "Responsabilità ambientale",
      envB1: "Siamo pienamente consapevoli che l'industria pesante può avere un impatto sull'ambiente che la circonda. Da questa consapevolezza nasce il nostro impegno: per VANROCK la responsabilità ambientale non è un obiettivo secondario ma un principio fondante, gestito con disciplina e una visione industriale di lungo periodo.",
      envB2: "La nostra produzione segue un approccio lean supportato dall'automazione dei processi, pensato per ridurre scarti, sprechi energetici e consumi inutili. Forgiare, lavorare e rifinire sotto lo stesso tetto accorcia la catena produttiva — meno passaggi, meno trasporti, meno sprechi.",
      envB3: "Consolidiamo le spedizioni e ottimizziamo imballaggi e logistica per ridurre l'impatto di ogni ordine che lascia i nostri magazzini.",
      envB4: "Il risultato è valore creato in modo sostenibile — per l'azienda, per le persone che lavorano con noi e per tutti gli stakeholder della nostra filiera.",
      socK: "02 Persone",
      socT: "Responsabilità sociale",
      socB1: "Le persone sono al centro di ogni decisione che prendiamo. Valorizziamo il talento, le relazioni di lungo periodo e le comunità locali intorno ai nostri siti, promuovendo formazione, autonomia e fiducia reciproca a ogni livello dell'azienda.",
      socB2: "Crediamo che un ambiente inclusivo, trasparente e collaborativo sia la base di una crescita autentica e duratura — un ambiente che riflette la diversità delle comunità in cui operiamo.",
      socB3: "Investiamo costantemente in attrezzature moderne e processi più sicuri per ridurre i rischi, prevenire gli incidenti e garantire condizioni di lavoro che rispettino la dignità di ogni persona.",
      socB4: "Questi principi sono formalizzati in un Codice di Condotta che guida i comportamenti in tutta l'azienda, affiancato da un canale di segnalazione riservato che tutela chi solleva una preoccupazione.",
      govK: "03 Governance",
      govT: "Governance",
      govB1: "Crediamo in un sistema di governance solido, strutturato e trasparente, capace di guidare lo sviluppo dell'azienda in modo etico e responsabile, generando valore di lungo periodo per tutti gli stakeholder.",
      govB2: "Per noi la governance è più di un insieme di regole: è il modo in cui costruiamo fiducia, manteniamo coerenti le nostre azioni e traduciamo i valori in pratica quotidiana.",
      govB3: "Il sistema è sostenuto da supervisione interna, attività di audit regolari e una gestione dei processi orientata alla prevenzione dei rischi, alla tracciabilità e alla misurazione delle prestazioni — dalla materia prima al ricambio spedito.",
      govB4: "La nostra gestione di qualità, ambiente e salute e sicurezza si fonda sui principi di standard riconosciuti a livello internazionale come ISO 9001, ISO 14001 e ISO 45001.",
      govB5: "La condotta etica è una condizione per lavorare con noi — internamente, con i fornitori e in tutta la rete di rivenditori.",
    },
    careers: {
      navLabel: "Lavora con noi",
      kicker: "Lavora con noi",
      title: "Costruisci la tua carriera su un terreno solido.",
      sub: "VANROCK cresce in quattro continenti. Cerchiamo sempre persone che prendono sul serio ingegneria, qualità e servizio.",
      whyK: "Perché VANROCK",
      whyT: "Cosa puoi aspettarti",
      w1t: "Produzione vera",
      w1b: "Forgiatura, lavorazione meccanica, trattamento termico e assemblaggio sotto lo stesso tetto — lavori vicino al prodotto, non lontano da esso.",
      w2t: "Presenza globale",
      w2b: "Uffici in Europa, Nord America, Australia e India, e una rete di rivenditori che copre il mondo.",
      w3t: "Spazio per crescere",
      w3b: "Un'azienda che cresce significa responsabilità che crescono. Chi rende bene, assume di più — in fretta.",
      areasK: "Aree di lavoro",
      areasT: "Dove potresti lavorare",
      a1: "Produzione e Ingegneria",
      a2: "Vendite e Sviluppo Rivenditori",
      a3: "Magazzino e Logistica",
      a4: "Amministrazione e Supporto",
      applyT: "Vuoi unirti a noi?",
      applyB: "Esaminiamo ogni candidatura che riceviamo. Raccontaci chi sei, cosa sai fare meglio e a quale ufficio o area sei interessato.",
      applyCta: "Contattaci",
      formK: "Candidatura",
      formT: "Entra in VANROCK",
      emailNote: "Preferisci l'email? Invia il tuo CV e una breve presentazione a",
      secPersonal: "Dati personali",
      secPosition: "Posizione",
      secExperience: "Esperienza",
      secDocs: "Documenti e messaggio",
      f_first: "Nome",
      f_last: "Cognome",
      f_email: "Email",
      f_phone: "Telefono",
      f_country: "Paese",
      f_city: "Città",
      f_area: "Area di lavoro",
      f_office: "Sede preferita",
      f_position: "Ruolo / posizione",
      f_type: "Tipo di impiego",
      t_full: "Tempo pieno",
      t_part: "Part-time",
      t_intern: "Stage / apprendistato",
      f_employer: "Datore di lavoro attuale",
      f_role: "Ruolo attuale",
      f_years: "Anni di esperienza",
      f_education: "Titolo di studio",
      f_langs: "Lingue",
      f_linkedin: "Profilo LinkedIn",
      f_salary: "Aspettativa salariale",
      f_start: "Prima data di inizio",
      f_relocate: "Sono disponibile a trasferirmi",
      f_heard: "Come ci hai conosciuto?",
      f_cover: "Lettera di presentazione / messaggio",
      f_cv: "CV (PDF o Word)",
      attach: "Allega CV",
      uploading: "Caricamento…",
      uploaded: "Allegato",
      submit: "Invia candidatura",
      sending: "Invio…",
      okT: "Candidatura ricevuta",
      okB: "Grazie — il nostro team esaminerà la tua candidatura e ti contatterà in caso di corrispondenza. Puoi scriverci anche a careers@vanrocktracksolutions.com.",
      err: "Qualcosa è andato storto. Riprova o scrivi a careers@vanrocktracksolutions.com.",
      select: "Seleziona…",
    },
    news: {
      navLabel: "Newsroom",
      kicker: "Newsroom",
      title: "Newsroom.",
      sub: "Annunci aziendali e novità di prodotto da VANROCK Track Solutions.",
      n1tag: "Azienda",
      n1date: "Maggio 2026",
      n1t: "VANROCK apre l'ufficio europeo a Monaco di Baviera",
      n1b: "Con l'apertura del nostro Ufficio Europeo Vendite e Sviluppo Rivenditori in Marcel-Breuer-Str. 15 a Monaco di Baviera, VANROCK si avvicina ai suoi rivenditori in tutta Europa. La nuova sede coordina lo sviluppo della rete, il supporto tecnico e le operazioni commerciali dell'intera regione, riducendo i tempi di risposta e rafforzando le partnership locali.",
      n2tag: "Prodotto",
      n2date: "Giugno 2026",
      n2t: "I cingoli in gomma entrano nella gamma VANROCK",
      n2b: "VANROCK amplia la gamma con una linea completa di cingoli in gomma per miniescavatori, pale compatte cingolate e dumper cingolati. Realizzati con cavi d'acciaio continui e mescole resistenti all'usura, ogni cingolo supera gli stessi standard di controllo dei nostri componenti in acciaio — disponibili attraverso la rete di rivenditori VANROCK.",
      n3tag: "Prodotto",
      n3date: "Giugno 2026",
      n3t: "I pattini in gomma completano la gamma",
      n3b: "Accanto ai cingoli in gomma, VANROCK aggiunge un programma completo di pattini in gomma — bolt-on, clip-on, chain-on e road pads — che proteggono asfalto e superfici pavimentate prolungando la vita del sottocarro. Compatibili con catene e suole VANROCK, tutte i pattini in gomma sono disponibili attraverso la rete di rivenditori VANROCK.",
      tabAll: "Tutto",
      tickerT: "VANROCK cresce con un nuovo ufficio — Ufficio Europeo Vendite e Sviluppo Rivenditori, Monaco di Baviera.",
      tickerCta: "Scopri di più",
      tabNews: "Notizie",
      tabEvents: "Eventi",
      mediaT: "Richieste stampa",
      mediaB: "Per richieste stampa e media, scrivici tramite la pagina contatti e indirizzeremo la tua richiesta all'ufficio giusto.",
      mediaCta: "Contattaci",
    },
  },
  de: {
    sust: {
      navLabel: "Nachhaltigkeit",
      kicker: "Nachhaltigkeit",
      title: "Verantwortung von Grund auf.",
      sub: "Wir verpflichten uns zu verantwortungsvollem Handeln — in der Fertigung, im Versand und im Umgang mit den Menschen, die unsere Arbeit möglich machen.",
      envK: "01 Umwelt",
      envT: "Ökologische Verantwortung",
      envB1: "Wir sind uns bewusst, dass Schwerindustrie die Umwelt um sie herum beeinflussen kann. Aus diesem Bewusstsein entsteht unser Engagement: Für VANROCK ist ökologische Verantwortung kein Nebenziel, sondern ein Gründungsprinzip — geführt mit Disziplin und einer langfristigen industriellen Vision.",
      envB2: "Unsere Fertigung folgt einem Lean-Ansatz, gestützt auf Prozessautomatisierung — ausgelegt darauf, Ausschuss, Energieverschwendung und unnötigen Verbrauch zu reduzieren. Schmieden, Bearbeiten und Endfertigung unter einem Dach verkürzen die Produktionskette — weniger Transfers, weniger Transport, weniger Abfall.",
      envB3: "Wir bündeln Sendungen und optimieren Verpackung und Logistik, um den Fußabdruck jeder Bestellung zu senken, die unsere Läger verlässt.",
      envB4: "Das Ergebnis ist nachhaltig geschaffener Wert — für das Unternehmen, für die Menschen, die mit uns arbeiten, und für alle Beteiligten unserer Lieferkette.",
      socK: "02 Menschen",
      socT: "Soziale Verantwortung",
      socB1: "Menschen stehen im Mittelpunkt jeder Entscheidung. Wir schätzen Talent, langfristige Beziehungen und die lokalen Gemeinschaften rund um unsere Standorte und fördern Ausbildung, Eigenverantwortung und gegenseitiges Vertrauen auf allen Ebenen.",
      socB2: "Wir sind überzeugt, dass ein inklusives, transparentes und kollaboratives Umfeld die Grundlage für echtes, dauerhaftes Wachstum ist — ein Umfeld, das die Vielfalt der Gemeinschaften widerspiegelt, in denen wir tätig sind.",
      socB3: "Wir investieren laufend in moderne Ausstattung und sicherere Prozesse, um Risiken zu minimieren, Unfälle zu verhindern und Arbeitsbedingungen zu gewährleisten, die die Würde jedes Einzelnen respektieren.",
      socB4: "Diese Grundsätze sind in einem Verhaltenskodex festgehalten, der das Handeln im gesamten Unternehmen leitet — ergänzt durch einen vertraulichen Meldekanal, der jeden schützt, der ein Anliegen meldet.",
      govK: "03 Governance",
      govT: "Governance",
      govB1: "Wir glauben an ein solides, strukturiertes und transparentes Governance-System, das die Entwicklung des Unternehmens ethisch und verantwortungsvoll steuert und langfristigen Wert für alle Beteiligten schafft.",
      govB2: "Governance ist für uns mehr als ein Regelwerk: Sie ist die Art, wie wir Vertrauen aufbauen, konsistent handeln und unsere Werte täglich in die Praxis umsetzen.",
      govB3: "Getragen wird das System von interner Aufsicht, regelmäßigen Audits und einem Prozessmanagement mit Fokus auf Risikoprävention, Rückverfolgbarkeit und Leistungsmessung — vom Rohmaterial bis zum versandten Teil.",
      govB4: "Unser Qualitäts-, Umwelt- und Arbeitsschutzmanagement orientiert sich an den Prinzipien international anerkannter Standards wie ISO 9001, ISO 14001 und ISO 45001.",
      govB5: "Ethisches Verhalten ist Voraussetzung für die Zusammenarbeit mit uns — intern, mit unseren Lieferanten und im gesamten Händlernetz.",
    },
    careers: {
      navLabel: "Karriere",
      kicker: "Karriere",
      title: "Bauen Sie Ihre Karriere auf festem Grund.",
      sub: "VANROCK wächst auf vier Kontinenten. Wir suchen laufend Menschen, die Engineering, Qualität und Service ernst nehmen.",
      whyK: "Warum VANROCK",
      whyT: "Was Sie erwarten können",
      w1t: "Echte Fertigung",
      w1b: "Schmieden, Zerspanung, Wärmebehandlung und Montage unter einem Dach — Sie arbeiten nah am Produkt, nicht weit davon entfernt.",
      w2t: "Globale Reichweite",
      w2b: "Büros in Europa, Nordamerika, Australien und Indien sowie ein Händlernetz, das die Welt umspannt.",
      w3t: "Raum zu wachsen",
      w3b: "Ein wachsendes Unternehmen bedeutet wachsende Verantwortung. Wer Leistung bringt, übernimmt mehr — schnell.",
      areasK: "Arbeitsbereiche",
      areasT: "Wo Sie arbeiten könnten",
      a1: "Produktion & Engineering",
      a2: "Vertrieb & Händlerentwicklung",
      a3: "Lager & Logistik",
      a4: "Verwaltung & Support",
      applyT: "Interesse, dabei zu sein?",
      applyB: "Wir prüfen jede Bewerbung, die uns erreicht. Sagen Sie uns, wer Sie sind, was Sie am besten können und welches Büro oder welcher Bereich Sie interessiert.",
      applyCta: "Kontakt aufnehmen",
      formK: "Bewerbung",
      formT: "Bewerben Sie sich bei VANROCK",
      emailNote: "Lieber per E-Mail? Senden Sie Ihren Lebenslauf und eine kurze Vorstellung an",
      secPersonal: "Persönliche Daten",
      secPosition: "Position",
      secExperience: "Erfahrung",
      secDocs: "Unterlagen & Nachricht",
      f_first: "Vorname",
      f_last: "Nachname",
      f_email: "E-Mail",
      f_phone: "Telefon",
      f_country: "Land",
      f_city: "Stadt",
      f_area: "Arbeitsbereich",
      f_office: "Bevorzugtes Büro",
      f_position: "Rolle / Position",
      f_type: "Beschäftigungsart",
      t_full: "Vollzeit",
      t_part: "Teilzeit",
      t_intern: "Praktikum / Ausbildung",
      f_employer: "Aktueller Arbeitgeber",
      f_role: "Aktuelle Rolle",
      f_years: "Jahre Berufserfahrung",
      f_education: "Höchster Abschluss",
      f_langs: "Sprachen",
      f_linkedin: "LinkedIn-Profil",
      f_salary: "Gehaltsvorstellung",
      f_start: "Frühester Eintritt",
      f_relocate: "Ich bin umzugsbereit",
      f_heard: "Wie sind Sie auf uns aufmerksam geworden?",
      f_cover: "Anschreiben / Nachricht",
      f_cv: "Lebenslauf (PDF oder Word)",
      attach: "Lebenslauf anhängen",
      uploading: "Wird hochgeladen…",
      uploaded: "Angehängt",
      submit: "Bewerbung absenden",
      sending: "Wird gesendet…",
      okT: "Bewerbung eingegangen",
      okB: "Vielen Dank — unser Team prüft Ihre Bewerbung und meldet sich, wenn es passt. Sie erreichen uns auch unter careers@vanrocktracksolutions.com.",
      err: "Etwas ist schiefgelaufen. Bitte erneut versuchen oder an careers@vanrocktracksolutions.com schreiben.",
      select: "Auswählen…",
    },
    news: {
      navLabel: "Newsroom",
      kicker: "Newsroom",
      title: "Newsroom.",
      sub: "Unternehmensmeldungen und Produktneuheiten von VANROCK Track Solutions.",
      n1tag: "Unternehmen",
      n1date: "Mai 2026",
      n1t: "VANROCK eröffnet Europa-Büro in München",
      n1b: "Mit der Eröffnung unseres europäischen Vertriebs- und Händlerentwicklungsbüros in der Marcel-Breuer-Str. 15 in München rückt VANROCK näher an seine Händler in ganz Europa. Das neue Büro koordiniert Händlerentwicklung, technischen Support und das operative Geschäft für die gesamte Region — für kürzere Reaktionszeiten und stärkere lokale Partnerschaften.",
      n2tag: "Produkt",
      n2date: "Juni 2026",
      n2t: "Gummiketten erweitern das VANROCK-Sortiment",
      n2b: "VANROCK erweitert sein Sortiment um ein komplettes Programm an Gummiketten für Minibagger, Kompakt-Raupenlader und Raupendumper. Gefertigt mit durchgehenden Stahlseilen und verschleißfesten Gummimischungen durchläuft jede Kette dieselben Prüfstandards wie unsere Stahl-Fahrwerkskomponenten — erhältlich über das VANROCK-Händlernetz.",
      n3tag: "Produkt",
      n3date: "Juni 2026",
      n3t: "Gummipads vervollständigen das Sortiment",
      n3b: "Neben Gummiketten nimmt VANROCK ein komplettes Programm an Gummipads auf — Bolt-on, Clip-on, Chain-on und Road Pads — die Asphalt und befestigte Flächen schützen und die Lebensdauer des Fahrwerks verlängern. Passend zu VANROCK-Kettengruppen und Bodenplatten, erhältlich über das VANROCK-Händlernetz.",
      tabAll: "Alle",
      tickerT: "VANROCK ist jetzt ein Büro stärker — Europäisches Vertriebs- und Händlerentwicklungsbüro, München.",
      tickerCta: "Mehr erfahren",
      tabNews: "News",
      tabEvents: "Veranstaltungen",
      mediaT: "Presseanfragen",
      mediaB: "Für Presse- und Medienanfragen erreichen Sie uns über unsere Kontaktseite — wir leiten Ihre Anfrage an das richtige Büro weiter.",
      mediaCta: "Kontakt aufnehmen",
    },
  },
  pt: {
    sust: {
      navLabel: "Sustentabilidade",
      kicker: "Sustentabilidade",
      title: "Responsáveis por princípio.",
      sub: "Comprometemo-nos a agir com responsabilidade — na forma como fabricamos, como enviamos e como tratamos as pessoas que tornam o nosso trabalho possível.",
      envK: "01 Ambiente",
      envT: "Responsabilidade ambiental",
      envB1: "Estamos plenamente conscientes de que a indústria pesada pode ter impacto no ambiente que a rodeia. É dessa consciência que nasce o nosso compromisso: para a VANROCK, a responsabilidade ambiental não é um objetivo secundário mas um princípio fundador, gerido com disciplina e uma visão industrial de longo prazo.",
      envB2: "A nossa produção segue uma abordagem lean apoiada na automação de processos, concebida para reduzir desperdícios, consumo de energia e gastos desnecessários. Forjar, maquinar e acabar sob o mesmo teto encurta a cadeia produtiva — menos transferências, menos transporte, menos desperdício.",
      envB3: "Consolidamos envios e otimizamos embalagem e logística para reduzir a pegada de cada pedido que sai dos nossos armazéns.",
      envB4: "O resultado é valor criado de forma sustentável — para a empresa, para as pessoas que trabalham connosco e para todos os intervenientes da nossa cadeia de fornecimento.",
      socK: "02 Pessoas",
      socT: "Responsabilidade social",
      socB1: "As pessoas estão no coração de cada decisão que tomamos. Valorizamos o talento, as relações de longo prazo e as comunidades locais em torno das nossas instalações, promovendo formação, autonomia e confiança mútua a todos os níveis.",
      socB2: "Acreditamos que um ambiente inclusivo, transparente e colaborativo é a base de um crescimento autêntico e duradouro — um ambiente que reflete a diversidade das comunidades onde operamos.",
      socB3: "Investimos continuamente em equipamentos modernos e processos mais seguros para minimizar riscos, prevenir acidentes e garantir condições de trabalho que respeitem a dignidade de cada pessoa.",
      socB4: "Estes princípios estão formalizados num Código de Conduta que orienta o comportamento em toda a empresa, apoiado por um canal de denúncia confidencial que protege quem levanta uma preocupação.",
      govK: "03 Governança",
      govT: "Governança",
      govB1: "Acreditamos num sistema de governança sólido, estruturado e transparente, capaz de orientar o desenvolvimento da empresa de forma ética e responsável, gerando valor de longo prazo para todas as partes interessadas.",
      govB2: "Para nós, a governança é mais do que um conjunto de regras: é a forma como construímos confiança, mantemos a coerência das nossas ações e traduzimos os nossos valores em prática diária.",
      govB3: "O sistema é apoiado por supervisão interna, auditorias regulares e uma gestão de processos centrada na prevenção de riscos, rastreabilidade e medição de desempenho — da matéria-prima à peça expedida.",
      govB4: "A nossa gestão de qualidade, ambiente e segurança e saúde assenta nos princípios de normas reconhecidas internacionalmente como a ISO 9001, a ISO 14001 e a ISO 45001.",
      govB5: "A conduta ética é condição para trabalhar connosco — internamente, com os fornecedores e em toda a rede de revendedores.",
    },
    careers: {
      navLabel: "Carreiras",
      kicker: "Carreiras",
      title: "Construa a sua carreira em terreno sólido.",
      sub: "A VANROCK cresce em quatro continentes. Procuramos sempre pessoas que levam a sério engenharia, qualidade e serviço.",
      whyK: "Porquê a VANROCK",
      whyT: "O que pode esperar",
      w1t: "Produção real",
      w1b: "Forja, maquinagem, tratamento térmico e montagem sob o mesmo teto — trabalha perto do produto, não longe dele.",
      w2t: "Alcance global",
      w2b: "Escritórios na Europa, América do Norte, Austrália e Índia, e uma rede de revendedores que cobre o mundo.",
      w3t: "Espaço para crescer",
      w3b: "Uma empresa em crescimento significa responsabilidades em crescimento. Quem entrega resultados, assume mais — rapidamente.",
      areasK: "Áreas de trabalho",
      areasT: "Onde poderia trabalhar",
      a1: "Produção e Engenharia",
      a2: "Vendas e Desenvolvimento de Revendedores",
      a3: "Armazém e Logística",
      a4: "Administração e Suporte",
      applyT: "Interessado em juntar-se?",
      applyB: "Analisamos todas as candidaturas que recebemos. Diga-nos quem é, o que faz melhor e que escritório ou área lhe interessa.",
      applyCta: "Contacte-nos",
      formK: "Candidatura",
      formT: "Junte-se à VANROCK",
      emailNote: "Prefere email? Envie o seu CV e uma breve apresentação para",
      secPersonal: "Dados pessoais",
      secPosition: "Posição",
      secExperience: "Experiência",
      secDocs: "Documentos e mensagem",
      f_first: "Nome",
      f_last: "Apelido",
      f_email: "Email",
      f_phone: "Telefone",
      f_country: "País",
      f_city: "Cidade",
      f_area: "Área de trabalho",
      f_office: "Escritório preferido",
      f_position: "Função / posição",
      f_type: "Tipo de emprego",
      t_full: "Tempo integral",
      t_part: "Tempo parcial",
      t_intern: "Estágio / aprendizagem",
      f_employer: "Empregador atual",
      f_role: "Função atual",
      f_years: "Anos de experiência",
      f_education: "Habilitações",
      f_langs: "Idiomas",
      f_linkedin: "Perfil de LinkedIn",
      f_salary: "Expectativa salarial",
      f_start: "Data de início mais próxima",
      f_relocate: "Estou disponível para mudar",
      f_heard: "Como nos conheceu?",
      f_cover: "Carta de apresentação / mensagem",
      f_cv: "CV (PDF ou Word)",
      attach: "Anexar CV",
      uploading: "A carregar…",
      uploaded: "Anexado",
      submit: "Enviar candidatura",
      sending: "A enviar…",
      okT: "Candidatura recebida",
      okB: "Obrigado — a nossa equipa irá analisar a sua candidatura e contactá-lo se houver correspondência. Também pode escrever para careers@vanrocktracksolutions.com.",
      err: "Algo correu mal. Tente novamente ou escreva para careers@vanrocktracksolutions.com.",
      select: "Selecionar…",
    },
    news: {
      navLabel: "Sala de imprensa",
      kicker: "Sala de imprensa",
      title: "Newsroom.",
      sub: "Anúncios corporativos e novidades de produto da VANROCK Track Solutions.",
      n1tag: "Empresa",
      n1date: "Maio 2026",
      n1t: "VANROCK abre escritório europeu em Munique",
      n1b: "Com a abertura do nosso Escritório Europeu de Vendas e Desenvolvimento de Revendedores em Marcel-Breuer-Str. 15, Munique, a VANROCK aproxima-se dos seus revendedores em toda a Europa. O novo escritório coordena o desenvolvimento de revendedores, o suporte técnico e as operações comerciais de toda a região — reduzindo os tempos de resposta e reforçando as parcerias locais.",
      n2tag: "Produto",
      n2date: "Junho 2026",
      n2t: "Lagartas de borracha juntam-se à gama VANROCK",
      n2b: "A VANROCK expande a sua gama com uma linha completa de lagartas de borracha para miniescavadoras, carregadoras compactas de rastos e dumpers de rastos. Fabricada com cabos de aço contínuos e compostos de borracha resistentes ao desgaste, cada lagarta cumpre os mesmos padrões de inspeção dos nossos componentes em aço — disponíveis através da rede de revendedores VANROCK.",
      n3tag: "Produto",
      n3date: "Junho 2026",
      n3t: "Sapatas de borracha completam a gama",
      n3b: "Juntamente com as lagartas de borracha, a VANROCK adiciona um programa completo de sapatas de borracha — bolt-on, clip-on, chain-on e road pads — que protegem o asfalto e as superfícies pavimentadas, prolongando a vida útil do material rodante. Compatíveis com as correntes e sapatas VANROCK, disponíveis através da rede de revendedores VANROCK.",
      tabAll: "Tudo",
      tickerT: "A VANROCK cresce com um novo escritório — Escritório Europeu de Vendas e Desenvolvimento de Revendedores, Munique.",
      tickerCta: "Saber mais",
      tabNews: "Notícias",
      tabEvents: "Eventos",
      mediaT: "Contactos de imprensa",
      mediaB: "Para pedidos de imprensa e media, contacte-nos através da nossa página de contacto e encaminharemos o seu pedido para o escritório certo.",
      mediaCta: "Contacte-nos",
    },
  },
};
;
